import React, { useEffect, useRef, useState } from "react";
import { Alert, Spin, theme, Typography } from "antd";
import { IEmailLocaleContent } from "../../../interfaces/emailTemplate.interface";
import { previewEmailTemplateServer } from "../emailTemplatesApi";

const { Text } = Typography;

interface EmailPreviewProps {
  slug: string;
  locale: string;
  content: IEmailLocaleContent;
  data: Record<string, unknown>;
}

const EmailPreview: React.FC<EmailPreviewProps> = ({
  slug,
  locale,
  content,
  data,
}) => {
  const { token } = theme.useToken();
  const [html, setHtml] = useState("");
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const serialized = JSON.stringify({ locale, content, data });

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await previewEmailTemplateServer({
          slug,
          payload: { locale, content, data },
        });
        setSubject(result.subject);
        setHtml(result.html);
      } catch (err) {
        setError("Failed to render preview.");
      } finally {
        setLoading(false);
      }
    }, 500);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, serialized]);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ marginBottom: token.marginXS }}>
        <Text type="secondary">SUBJECT</Text>
        <div>
          <Text strong>{subject || "—"}</Text>
          {loading && (
            <Spin size="small" style={{ marginLeft: token.marginXS }} />
          )}
        </div>
      </div>
      {error && (
        <Alert
          type="error"
          message={error}
          style={{ marginBottom: token.marginXS }}
        />
      )}
      <iframe
        title="email-preview"
        srcDoc={html}
        style={{
          flex: 1,
          minHeight: 480,
          width: "100%",
          border: `1px solid ${token.colorBorder}`,
          borderRadius: token.borderRadius,
          background: "#fff",
        }}
      />
    </div>
  );
};

export default EmailPreview;
